import React from 'react';
import styled from '@emotion/styled';

import EasyJoinForm from '../presentational/EasyJoinForm';
import Logo from '../../../../shared/images/full-logo-black-orange.png';
import SubText from '../../../../shared/_TBComponents/SubText';

const FormArea = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 30px 54px;
  position: relative;

  @media screen and (max-width: 600px) {
    padding: 30px;
  }
`;

const FormContainer = styled('div')`
  background-color: white;
  height: auto;
  padding-bottom: 40px;
  width: 430px;

  @media screen and (max-width: 600px) {
    height: auto;
    padding-bottom: 20px;
    width: 330px;
  }
`;

const TitleArea = styled('div')`
  align-items: center;
  border-bottom: 2px solid rgb(232, 232, 232);
  display: flex;
  flex-direction: column;
  height: 160px;
  justify-content: center;
  padding: 30px 80px 5px 80px;
  width: 100%;

  img {
    margin-bottom: 20px;
  }

  @media screen and (max-width: 600px) {
    height: 135px;
  }
`;

const EasyJoinFormContainer = () => (
  <FormContainer>
    <TitleArea>
      <img
        alt='Teambuildr'
        className='img-fluid'
        src={Logo}
      />
      <SubText>
        Easy Join
      </SubText>
    </TitleArea>
    <FormArea>
      <EasyJoinForm />
    </FormArea>
  </FormContainer>
);

export default EasyJoinFormContainer;
